import { CopyIcon } from '../../../../../design-system/copy-icon/copy-icon';
import { Inline } from '../../../../../design-system/inline/inline';
import { Stack } from '../../../../../design-system/stack/stack';

type AccountDetailsProps = {
  accountDetails: {
    iban?: string;
    sortCode?: string;
    accountNumber?: string;
  };
};

type DetailRowProps = {
  label: string;
  value: string;
  labelWidth?: string;
};

const DetailRow = ({ label, value, labelWidth = 'w-1/3' }: DetailRowProps) => (
  <Inline space={2} className="w-full flex-nowrap" justify="between">
    <div className={`${labelWidth} text-xs font-thin leading-[22px] tracking-[-0.02em] text-seapoint-gray-text`}>
      {label}
    </div>
    <Inline className="w-full rounded-lg bg-white pl-2 text-xs" justify="between">
      {value}
      <CopyIcon textToCopy={value} />
    </Inline>
  </Inline>
);

export const AccountDetails = ({ accountDetails }: AccountDetailsProps) => {
  if (!accountDetails.iban && !accountDetails.sortCode && !accountDetails.accountNumber) {
    return null;
  }

  return (
    <div className="w-full rounded-lg bg-seapoint-gray-background-modal p-4">
      <p className="mb-5 text-base font-medium leading-[22px] tracking-[-0.02em]">Account Details</p>

      {accountDetails.iban && <DetailRow label="IBAN" value={accountDetails.iban} />}

      {accountDetails.sortCode && accountDetails.accountNumber && (
        <Stack space={2}>
          <DetailRow label="Account Number" value={accountDetails.accountNumber} labelWidth="w-2/5" />
          <DetailRow label="Sort Code" value={accountDetails.sortCode} labelWidth="w-2/5" />
        </Stack>
      )}
    </div>
  );
};
